import { I18n } from '@calendly/i18n';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { PastMeetingIcon } from '../icons';
import { toggleContactDrawerOpen, setCurrentContact } from '../slice';
const sectionHeaderCss = "s1un00hy";
const SectionHeader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sectionHeaderCss, props.className)} />;
});
const pastMeetingVerticalLineCss = "p1pv6deu";
const PastMeetingVerticalLine = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(pastMeetingVerticalLineCss, props.className)} />;
});
const meetingTitleRowCss = "m1gz486n";
const MeetingTitleRow = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(meetingTitleRowCss, props.className)} />;
});
const styledBodyTextCss = "s1m4g900";
const StyledBodyText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(styledBodyTextCss, props.className)} />;
});
const meetingDataRowCss = "mw5rltg";
const MeetingDataRow = forwardRef((props, ref) => <MeetingTitleRow ref={ref} {...props} className={classNames(meetingDataRowCss, props.className)} />);
const meetingContainerCss = "m1urdczu";
const MeetingContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(meetingContainerCss, props.className)} />;
});
const pastMeetingContainerCss = "p1y5clb2";
const PastMeetingContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(pastMeetingContainerCss, props.className)} />;
});
const containerCss = "c1vsjfsm";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const renderMeeting = mtg => <MeetingContainer key={mtg.uuid}>
    <MeetingTitleRow>
      <PastMeetingIcon />
      <StyledBodyText>
        <BodyText>
          {mtg.name}
        </BodyText>
      </StyledBodyText>
    </MeetingTitleRow>
    <MeetingDataRow>
      <PastMeetingVerticalLine />
      <StyledBodyText>
        <BodyText color="muted" size="medium">
          {`${mtg.date}, ${mtg.startTime}-${mtg.endTime}`}
        </BodyText>
      </StyledBodyText>
    </MeetingDataRow>
  </MeetingContainer>;
export const PastMeetingHistory = ({
  pastMeetings,
  onShowAll
}) => {
  const dispatch = useDispatch();
  const isMobile = useDeviceType('isPhone');
  const handleOnViewAllClick = () => {
    onShowAll();
    if (isMobile) {
      dispatch(toggleContactDrawerOpen());
      dispatch(setCurrentContact(null));
    }
  };
  if ((pastMeetings?.length ?? 0) < 1) {
    return null;
  }
  return <Container>
      <SectionHeader>
        <BodyText size="medium" color="muted" weight="bold">{I18n.t('publisher.contacts.profile.meeting_history')}</BodyText>
        <MinimalButton spacingRight={16} onClick={handleOnViewAllClick}>
          {I18n.t('publisher.contacts.profile.view_all')}
        </MinimalButton>
      </SectionHeader>
      <PastMeetingContainer>
        {pastMeetings.map(meeting => renderMeeting(meeting))}
      </PastMeetingContainer>
    </Container>;
};

require("./past_meeting_history.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./past_meeting_history.js");